var checkout_selectors =
    "input[name='checkout'], input[value='Checkout'], button[name='checkout'], [href$='checkout'], button[value='Checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], #cart-checkout, #cart-sidebar-checkout, .button-checkout";


window.omlWatchInventoryCheckout = function (process) {
    $.getJSON("/cart.js", function (cart) {
        var domain = location.hostname;
        window.oml.cart = cart;
        $.ajax({
            type: "POST",
            contentType: "application/json",
            url:
                "https://" +
                domain +
                "/apps/watchguy/page/checkout-link",
            data: JSON.stringify({
                cart: cart,
                customer_id: window.oml.customer_id
            }),
            crossDomain: true,
            success: function (res) {
                if (res !== null && typeof res.checkoutUrl !== "undefined") {
                    process(res.checkoutUrl);
                }
            },
        });
    });
};


window.omlCheckoutRedirect = function(url){
    if (typeof url == "string") {
        window.location.href = url;
    } else {
        window.location.href = "/checkout";
    }
}

window.omlCheckoutDataAttributes = function(url){
    var $elems = $(checkout_selectors);
    console.log("omlCheckoutDataAttributes", url);
    if (typeof url == "string") {
        $elems.attr("data-href", url);
        $elems.removeAttr("onclick");
    }
}


$(document).on("click", checkout_selectors, function (e) {
    e.preventDefault();
    e.stopPropagation();
    omlWatchInventoryCheckout(omlCheckoutRedirect);
});

$(document).ready(function() {
    var $elems = $(checkout_selectors);
    if ($elems.data('href') || $elems.click != undefined) {
        omlWatchInventoryCheckout(omlCheckoutDataAttributes);
    }
});